import React, { useContext, useState } from 'react';
import Button from '../Global/Button';
import { useForm } from 'react-hook-form';

//@ts-ignore
import * as styles from './what-sauna.module.css';
import RichText from '../Global/RichText';
import { WhatSaunaProps } from './index';
import WhatSaunaResultsContainer from '../WhatSaunaResults/index';
import { ProductPagePreview } from '../Global/DataUtils/productQueries';
import {
    optimizeKontentImageUrl,
    getDisplayDimensions,
} from '../Global/DataUtils';
import LazyImage from '../Global/LazyImage';
import * as fadeStyles from '../Global/fade.module.css';
import { PageMetadataContext } from '../../templates/PageMetaDataContext';

import Jotform from '../Jotform';

interface WellnessType {
    codename: string;
    name: string;
    img: string | { url: string; width: number; height: number };
}
interface FormProps extends WhatSaunaProps {
    allProducts: ProductPagePreview[];
    wellness_type_for_german_site: {
        value: WellnessType[];
    };
    wellness_type_for_french_site: {
        value: WellnessType[];
    };
}

const WhatSaunaForm: React.FC<FormProps> = ({
    allProducts,
    headline,
    description_copy,
    interested_in_subheadline,
    anchor_name,
    contact_form,
    capacity_need_subheadline,
    wellness_type,
    capacity_tag,
    capacity_tag_for_german_site,
    capacity_tag_for_french_site,
    results_headline,
    cta_label,
    wellness_type_for_german_site,
    wellness_type_for_french_site,
    kontentItemId,
    ...props
}) => {
    const {
        register,
        handleSubmit,
        formState: { errors },
    } = useForm();
    const [showEmailForm, setShowEmailForm] = useState(false);
    const [emailFormParams, setEmailFormParams] = useState('');
    const [selectedWellnessTags, setSelectedWellnessTags] = useState([]);
    const [selectedCapacity, setSelectedCapacity] = useState('');
    const [showResults, setShowResults] = useState(false);
    const pageMetadata = useContext(PageMetadataContext);
    const capacityTag =
        pageMetadata.preferredLanguage == 'de-de'
            ? capacity_tag_for_german_site
            : pageMetadata.preferredLanguage == 'fr-fr'
            ? capacity_tag_for_french_site
            : capacity_tag;

    const setWellnessTypeForGerman = () => {
        return wellness_type?.value?.map((type, index) => {
            type.name = wellness_type_for_german_site?.value[index]?.name;
            if (wellness_type_for_german_site?.value[index]?.img) {
                type.img = wellness_type_for_german_site?.value[index]?.img;
            }
            return type;
        });
    };

    const setWellnessTypeForFrance = () => {
        return wellness_type?.value?.map((type, index) => {
            type.name = wellness_type_for_french_site?.value[index]?.name;
            if (wellness_type_for_french_site?.value[index]?.img) {
                type.img = wellness_type_for_french_site?.value[index]?.img;
            }
            return type;
        });
    };

    const wellnessType =
        pageMetadata.preferredLanguage == 'de-de'
            ? setWellnessTypeForGerman()
            : pageMetadata.preferredLanguage == 'fr-fr'
            ? setWellnessTypeForFrance()
            : wellness_type.value;

    const onSubmit = (data: any) => {
        const wellness = Array.isArray(data.wellnessTags)
            ? data?.wellnessTags?.join(',')
            : data.wellnessTags;

        setSelectedWellnessTags(data?.wellnessTags);
        setSelectedCapacity(data?.capacity);

        if (contact_form?.value) {
            setEmailFormParams(
                `&capacity=${data?.capacity}&wellness=${wellness}`
            );
            setShowEmailForm(true);
        } else {
            setShowResults(true);
        }
    };

    const handleEmailFormDone = () => {
        setShowResults(true);
    };

    const handleEmailFormReady = () => {
        // form ready
    };

    return (
        <section
            className={styles.section}
            id={anchor_name?.value}
            data-kontent-item-id={kontentItemId}
        >
            {!showResults && (
                <div className={styles.container}>
                    <div className={styles.contentWrapper}>
                        <div className={styles.content}>
                            <h2 data-kontent-element-codename="headline">
                                {headline?.value}
                            </h2>
                            {RichText(
                                description_copy,
                                false,
                                undefined,
                                undefined,
                                'description_copy'
                            )}
                        </div>
                    </div>
                    <div className={styles.quiz}>
                        <form onSubmit={handleSubmit(onSubmit)}>
                            <div>
                                <label
                                    className={styles.largeLabel}
                                    data-kontent-element-codename="interested_in_subheadline"
                                >
                                    {interested_in_subheadline?.value}
                                </label>
                                <div className={styles.selections}>
                                    {wellnessType?.map((tag) => (
                                        <div
                                            key={tag.codename}
                                            className={styles.selection}
                                        >
                                            <input
                                                type="checkbox"
                                                placeholder="Please select an option."
                                                id={tag.codename}
                                                value={tag.codename}
                                                className="sr-only"
                                                {...register('wellnessTags', {
                                                    required: true,
                                                })}
                                            />
                                            <label
                                                className={styles.imageLabel}
                                                htmlFor={tag.codename}
                                                data-kontent-element-codename="image"
                                            >
                                                {tag.img &&
                                                    typeof tag.img ===
                                                        'object' && (
                                                        <LazyImage
                                                            src={optimizeKontentImageUrl(
                                                                (
                                                                    tag.img as {
                                                                        url: string;
                                                                        width: number;
                                                                        height: number;
                                                                    }
                                                                ).url,
                                                                {
                                                                    w: 152,
                                                                    fm: 'webp',
                                                                    q: 80,
                                                                    fit: 'crop',
                                                                }
                                                            )}
                                                            alt={tag.name ?? ''}
                                                            {...getDisplayDimensions(
                                                                (
                                                                    tag.img as {
                                                                        width?: number;
                                                                        height?: number;
                                                                    }
                                                                ).width,
                                                                (
                                                                    tag.img as {
                                                                        width?: number;
                                                                        height?: number;
                                                                    }
                                                                ).height,
                                                                152
                                                            )}
                                                        />
                                                    )}
                                                <span
                                                    className={
                                                        styles.smallLabel
                                                    }
                                                >
                                                    {tag.name}
                                                </span>
                                            </label>
                                        </div>
                                    ))}
                                </div>
                                {errors?.wellnessTags?.message && (
                                    <p>{errors.wellnessTags.message}</p>
                                )}
                            </div>
                            <div className={styles.roomSelection}>
                                <label
                                    htmlFor="capacity"
                                    className={styles.largeLabel}
                                    data-kontent-element-codename="capacity_need_subheadline"
                                >
                                    {capacity_need_subheadline?.value + ' '}
                                </label>
                                <div className="select-wrapper select-wrapper--alt-orange">
                                    <select
                                        id="capacity"
                                        {...register('capacity', {
                                            required: true,
                                        })}
                                    >
                                        {capacityTag?.value?.map((tag) => (
                                            <option
                                                key={tag.codename}
                                                value={tag.codename}
                                            >
                                                {tag.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                                <Button
                                    type="submit"
                                    visualStyle="outlineDark"
                                    data-kontent-element-codename="cta_label"
                                >
                                    {cta_label?.value
                                        ? cta_label?.value
                                        : 'FIND MY SAUNA'}
                                </Button>
                            </div>
                        </form>
                    </div>
                    {showEmailForm && contact_form?.value && (
                        <Jotform
                            formUrl={contact_form?.value}
                            formStyle="popup"
                            params={emailFormParams}
                            onPopUpClose={handleEmailFormDone}
                            display={true}
                        />
                    )}
                </div>
            )}
            {showResults && (
                <div className={fadeStyles.fadeIn}>
                    <WhatSaunaResultsContainer
                        allProducts={allProducts}
                        results_headline={results_headline}
                        selectedWellnessTags={selectedWellnessTags}
                        selectedCapacity={selectedCapacity}
                        {...props}
                    />
                </div>
            )}
        </section>
    );
};

export default WhatSaunaForm;
